module.exports = __webpack_public_path__ + "img/recycle-bin.704ee29d.png";